const DormantPoolRoute = {
  path: '/customer/dormant',
  load: () => import('./DormantPool'),
  protected: true,
};

export { DormantPoolRoute };
